/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import { useDataContext } from '../context';
import { useCookies } from 'react-cookie';

const API_URL = import.meta.env.VITE_API_URL;

function GetOrganizeList() { // เปลี่ยนชื่อให้ตรงกับ API (เดิม AllDepartment)
  const { data, setData } = useDataContext();
  
  // ใช้ hook ดึง cookie (ถ้า cookie empeoToken มา React จะสั่ง run useEffect นี้เอง ไม่ต้องวนลูปเช็ค)
  const [cookies] = useCookies(['empeoToken']);
  
  // ตัวกันยิงซ้ำ
  const hasFetched = useRef(false);

  useEffect(() => {
    // 1. เช็คว่ามีข้อมูลใน Context แล้วหรือยัง? (ถ้ามีแล้ว ไม่ต้องโหลด)
    if (data.empeoGetOrganization && data.empeoGetOrganization.length > 0) {
      return;
    }

    // 2. เช็คว่ามี Token หรือยัง?
    const token = cookies.empeoToken;
    if (!token) return; // ถ้าไม่มี token ก็รอไปก่อน (พอ cookie มา useEffect จะรันใหม่เอง)

    // 3. เช็คว่าเคยยิงไปแล้วหรือยัง (Strict Mode Protection)
    if (hasFetched.current) return;

    const fetchData = async () => {
      hasFetched.current = true;
      try {
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');

        const raw = JSON.stringify({
          Authorization: token,
          CompanyName: 'บริษัท บุญศิริโฟรเซ่นโปรดักส์ จำกัด',
        });

        const response = await fetch(`${API_URL}/empeoGetOrganization`, {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow',
        });

        const result = await response.json();

        if (result.data) {
          setData((prevData) => ({
            ...prevData,
            empeoGetOrganization: result?.data?.data,
          }));
          // console.log('✅ Organization Data loaded');
        }
      } catch (error) {
        console.error('API error (GetOrganizeList):', error);
        hasFetched.current = false; // Reset เพื่อให้ลองใหม่ได้ถ้า Error
      }
    };

    fetchData();

  }, [cookies.empeoToken]); // Dependency: ทำงานเมื่อ Token เปลี่ยน/เข้ามา

  return null;
}

export default GetOrganizeList;